'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$print", function ($rootScope, $timeout, $compile) {
  var printMode = false,
    toolbarLinkFn,
    toolbarEl,
    toolbarScope,
    onDisableCallback;
  var showToolbar = function showToolbar() {
    hideToolbar();
    if (toolbarLinkFn == null) {
      toolbarLinkFn = $compile($("<print-toolbar>"));
    }
    toolbarScope = $rootScope.$new();
    toolbarLinkFn(toolbarScope, function (clone) {
      toolbarEl = clone;
    });
    toolbarEl.appendTo(document.body);
  };
  var hideToolbar = function hideToolbar() {
    if (toolbarScope != null) {
      toolbarScope.$destroy();
      toolbarScope = null;
    }
    if (toolbarEl != null) {
      toolbarEl.remove();
      toolbarEl = null;
    }
  };
  return {
    isPrintEnabled: function isPrintEnabled() {
      return printMode;
    },
    enablePrint: function enablePrint(disableCallback) {
      if (printMode === true) {
        return;
      }
      onDisableCallback = disableCallback;
      $("html").addClass("print-mode");
      $("<div>").addClass("tl-print-overlay").appendTo($(".main-wrapper"));
      $rootScope.$broadcast("$print:enabled");
      $rootScope.$broadcast("$print:toggle", true);
      showToolbar();
      $timeout(function () {
        $rootScope.$broadcast("$resize-x");
      }, 50);
      printMode = true;
    },
    disablePrint: function disablePrint() {
      if (printMode === false) {
        return;
      }
      $("html").removeClass("print-mode");
      $(".tl-print-overlay").remove();
      $rootScope.$broadcast("$print:disabled");
      $rootScope.$broadcast("$print:toggle", false);
      hideToolbar();
      $timeout(function () {
        $rootScope.$broadcast("$resize-x");
      }, 50);
      printMode = false;
      if (onDisableCallback != null) {
        onDisableCallback();
        onDisableCallback = null;
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/print/print.js
// module id = 2717
// module chunks = 13